import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/tmp/img-empty@3x.png'
import _imports_1 from '@/assets/img/tmp/img-nodata@3x.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-78827887")

_pushScopeId("data-v-78827887")
const _hoisted_1 = {
  class: "gift_box_completion_wrap",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "gift_box_completion" }
const _hoisted_3 = { class: "completion_box" }
const _hoisted_4 = { class: "box_info" }
const _hoisted_5 = { class: "img_area" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_8 = { class: "txt" }
const _hoisted_9 = { class: "btn_area btn_area2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            (_ctx.showGiftImage)
              ? (_openBlock(), _createBlock("img", _hoisted_6))
              : (_openBlock(), _createBlock("img", _hoisted_7))
          ]),
          _createVNode("h1", _hoisted_8, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("button", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.moveToHome && _ctx.moveToHome(...args)), ["prevent"])),
              type: "button",
              class: "btn btn_buy"
            }, "선물하러 가기")
          ])
        ])
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.isEmpty]
  ])
})